import phone from "phone";
import { PHONE_NUMBER_REGEX } from "../foundation/constants/regex";

export function checkIsValidPhoneNumber(phoneNumber: string) {
  return (
    phone(phoneNumber, { country: "USA" }).isValid && // Ensure the number is actually real
    new RegExp(PHONE_NUMBER_REGEX).test(phoneNumber) // Ensure the pattern matches because isValid will ignore characters/symbols/whitespace
  );
}
